import React from 'react';
import {Modal, Form, Tree, Button, Input} from 'antd';
import {locdau} from '../utils'
const FormItem = Form.Item;
const TreeNode = Tree.TreeNode;
const Search = Input.Search;

class GroupModalSelectForm extends React.Component {
  constructor(props) {
    super(props);
    const {group} = this.props
    const keyGroupSlected = group
      ? group.ID
      : ''
    this.state = {
      expandedKeys: [keyGroupSlected],
      autoExpandParent: true,
      selectedKeys: [keyGroupSlected],
      searchValue: ''
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({groups: nextProps.groups})
  }

  handleSelect = (selectedKeys, info) => {
    const selected = info.node.props.dataRef
    const {form, treeGroups} = this.props
    form.setFieldsValue({GroupID: selected.ID, GroupName: selected.Name});
    this.setState({selectedKeys});
  }

  hanldeExpand = (expandedKeys) => {
    this.setState({expandedKeys, autoExpandParent: false});
  }

  hanldleSearchChange = (e) => {
    const value = e.target.value
    const {groups} = this.props
    const parentKeys = groups.filter((item) => {
      const kodau = locdau(item.Name).toLowerCase()
      const kodauSearch = locdau(value).toLowerCase()
      return kodau.indexOf(kodauSearch) > -1
    }).map(item => item.ParentID)
    this.setState({expandedKeys: parentKeys, autoExpandParent: true, searchValue: value})
  }

  isChild = (id, treeGroups) => {

  }

  render() {
    const {
      group,
      treeGroups,
      title,
      visible,
      onCancel,
      onSubmit,
      form
    } = this.props
    const {getFieldDecorator} = form
    const {expandedKeys, autoExpandParent, selectedKeys, searchValue} = this.state

    const loop = treeGroups => treeGroups.map((item) => {
      const kodau = locdau(item.Name).toLowerCase()
      const kodauSearch = locdau(searchValue).toLowerCase()
      const index = kodau.indexOf(kodauSearch);
      const beforeStr = item.Name.substr(0, index);
      const matchStr = item.Name.substr(index, searchValue.length);
      const afterStr = item.Name.substr(index + searchValue.length);
      const title = index > -1
        ? (<span>
          {beforeStr}
          <span style={{
              color: '#f50'
            }}>{matchStr}</span>
          {afterStr}
        </span>)
        : <span>{item.Name}</span>;

      if (item.Childs.length > 0) {
        return (<TreeNode title={title} dataRef={item} key={item.ID}>
          {loop(item.Childs)}
        </TreeNode>);
      }
      return <TreeNode title={title} dataRef={item} key={item.ID}/>;
    })
    return (<Modal visible={visible} title={title} okText="Lưu" cancelText="Bỏ qua" onCancel={onCancel} onOk={onSubmit} footer={[
        <Button key="cancel" onClick={onCancel}>Bỏ qua</Button>,
        <Button key="submit" type="primary" ghost="ghost" onClick={onSubmit}>
          Lưu
        </Button>
      ]}>
      <Form layout="vertical">
        <FormItem>
          {
            getFieldDecorator('GroupID', {
              rules: [
                {
                  required: true,
                  message: 'Phải chọn địa bàn!'
                }
              ],
              initialValue: group.ID
            })(<div>
              <Search style={{
                  marginBottom: 8,
                  width: '100%'
                }} placeholder="Nhập địa bàn" onChange={this.hanldleSearchChange}/>
              <Tree expandedKeys={expandedKeys} autoExpandParent={autoExpandParent} onExpand={this.hanldeExpand} onSelect={this.handleSelect} selectedKeys={selectedKeys}>
                {loop(treeGroups)}
              </Tree>
            </div>)
          }
        </FormItem>
        {getFieldDecorator('GroupName', {initialValue: group.Name})(<span/>)}
      </Form>
    </Modal>);
  }
}

export default Form.create()(GroupModalSelectForm)



// WEBPACK FOOTER //
// ./src/components/GroupModalSelectForm.js